import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from '@angular/common/http';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const ɵ0 = adapterFactory;
// import { SafePipe } from './safePipe.pipe';
export class AppModule {
}
export { ɵ0 };
